import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

import "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";

import { configureAmplify } from "./services/AmplifyConfig";
import Spin from "./components/Diverse/Spin";

configureAmplify();

ReactDOM.render(
  <Suspense fallback={<Spin />}>
    <React.StrictMode>
      <App />
    </React.StrictMode>{" "}
  </Suspense>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
